<template>
  <el-table-column
    prop="name"
    label="Üzlet"
    show-overflow-tooltip
    min-width="190"
    fixed
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.id"
      >
        <strong>#{{ scope.row.id }}</strong> {{ scope.row.name }}<br>
        <el-tag size="mini" type="info" v-if="scope.row.address">
          {{ scope.row.address.postal_code }} {{ scope.row.address.city }} {{ scope.row.address.street }} {{ scope.row.address.street_suffix }} {{ scope.row.address.street_no }}
        </el-tag>
      </div>
      <div
        v-else
      >
        {{ scope.row.name }} ({{ scope.row.shop_count }} üzlet)
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'shop.name',
  };
</script>
